module.exports = __webpack_public_path__ + "img/catalog.589c0112.png";